<script>
  import {
    rolesMethods,
  } from '@state/helpers'

  export default {
    data() {
      return {
        roles: [],
        boundCollapse: true,
      }
    },
    computed:{
      roleFilters(){
        return this.roles.map(el => {
          if (el.selected){
            return el.id
          }
        }).filter(el => el)
      }
    },
    watch: {
      roleFilters (val) {
        this.$emit('filter', {
          role_ids: val,
        })
      },
    },
    async created() {
      return this.loadRoles()
    },
    methods: {
      ...rolesMethods,
      async loadRoles () {
        const { data } = await this.getListRoles({
          fields: 'id, name',
          limit: 500,
          orderBy: 'name',
          sortedBy: 'asc',
        })
        const roles = data.data
        roles.forEach(el => el.selected = false)
        this.roles = roles
      },
    },
  }
</script>

<template>
  <div v-bind="$attrs" class="block-item">
    <div class="block-heading">
      <h3
        v-fabric-collapse.accordion-role
        class="
          tw-flex tw-items-center
          tw-text-positive
          tw-leading-relaxed tw-font-medium tw-text-base">
        <a class="tw-no-underline" href="javascript:">Filter by role</a>
        <BaseChevronRotate
          transition-class="rotate-360-270"
          :toggle="!boundCollapse"
          :duration="500"
        />
      </h3>
      <FabricBadge
        :styling-bg="roleFilters.length ? 'badge-primary' : 'badge-light'"
        :copy="roleFilters.length"
      />
    </div>
    <FabricCollapse
      id="accordion-role"
      v-model="boundCollapse"
      hide-header
      :duration="500"
      class="table-filters">
      <div
        class="block-content"
        :class="{ 'ovf-y-scroll tw-overflow-x-hidden scroll-primary mg-r-5 pd-t-u mg-t-10 mx-h-300': (roles && roles.length > 8) }">
        <FabricCheckbox
          v-for="role in roles"
          :key="role.id"
          v-model="role.selected"
          slot-classes="tw-pl-3 tw-text-black"
        >{{ role.name }}</FabricCheckbox>
      </div>
    </FabricCollapse>
  </div>
</template>
